var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenpit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 12V0H28V7.6L24.8 12H15.2L12 7.6V0H0V12H4V28H0V40H12V36H28V40H40V28H36V12H40ZM18 16H22V20H18V16ZM4 4H8V8H4V4ZM8 36H4V32H8V36ZM28 32H12V28H8V12H10.2L14 17.2V24H26V17.2L29.8 12H32V28H28V32ZM36 36H32V32H36V36ZM32 8V4H36V8H32Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenpit);
export default __webpack_public_path__ + "static/media/openpit.ad51d170c6ec4d013bcfc893cdf002ba.svg";
export { ForwardRef as ReactComponent };